import { Component, ViewChild, Injector, Output, EventEmitter, OnInit, Input } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { finalize } from 'rxjs/operators';
import { MetaTemplateInfosServiceProxy, CreateOrEditMetaTemplateInfoDto, MetaTemplateInfoDto } from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DateTime } from 'luxon';
import { map as _map, filter as _filter, pick as _pick, sortBy as _sortBy } from 'lodash-es';
import { DateTimeService } from '@app/shared/common/timing/date-time.service';



@Component({
    selector: 'createOrEditMeta',
    templateUrl: './create-or-edit-meta.component.html'
})
export class CreateOrEditMetaComponent extends AppComponentBase implements OnInit {

    @ViewChild('createOrEditModal', { static: true }) modal: ModalDirective;
    @Input() data: string;
    @Input() isDisable: boolean;
    @Output() dataChange = new EventEmitter();

    active = false;
    saving = false;
    templateData: MetaTemplateInfoDto[] = [];
    metaTemplateInfo: CreateOrEditMetaTemplateInfoDto = new CreateOrEditMetaTemplateInfoDto();




    constructor(
        injector: Injector,
        private _metaTemplateInfosServiceProxy: MetaTemplateInfosServiceProxy,
        private _dateTimeService: DateTimeService
    ) {
        super(injector);
    }

    valueChange() {
        this.data = JSON.stringify(this.templateData);
        this.dataChange.emit(this.data);
    }

    show(meta:string):void{
        this.data = meta;
        this.templateData = [];
        this.ngOnInit();
    }
    ngOnInit(): void {
        this.templateData = [];
        try {
            var objArray = JSON.parse(this.data);
            if (Array.isArray(objArray)) {
                for (let item of objArray)
                    this.templateData!.push(MetaTemplateInfoDto.fromJS(item));
            }
        } catch {

        }




        this._metaTemplateInfosServiceProxy.getAll(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, "Order asc", 0, 999)
            .pipe(finalize(() => { this.saving = false; }))
            .subscribe((result) => {
                for (var i = 0; i < result.items.length; i++) {
                    var curentItem = this.templateData.filter(c => c.id == result.items[i].metaTemplateInfo.id);
                    if (!curentItem || curentItem.length<=0) {
                        this.templateData.push(result.items[i].metaTemplateInfo);
                    } else{
                        curentItem[0].isAllowEdit = result.items[i].metaTemplateInfo.isAllowEdit;
                        curentItem[0].isAutoUpdateByContent = result.items[i].metaTemplateInfo.isAutoUpdateByContent;
                        curentItem[0].isHidden = result.items[i].metaTemplateInfo.isHidden;
                        curentItem[0].order = result.items[i].metaTemplateInfo.order;
                    }

                }
                this.templateData = _sortBy(this.templateData, c=>c.order);
            });
    }
}
